import { Menu as AntdMenu } from 'antd';
import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useProjectTemplateSpaces } from 'data/templates/projects';
import { createSpaceInProjectTemplate } from 'data/templates/projects/actions';
import { useTranslation } from 'hooks/use-translation';
import { MenuGroup } from './menu-group';

const Menu = styled(AntdMenu)`
  border-right: 0;
  margin: var(--spacing-03) calc(-1 * var(--layout-01));
  width: auto;

  .ant-menu-item-divider {
    margin: var(--layout-02) var(--layout-01);
  }
`;

export const ProjectTemplateSpacesLeftNav: FC = () => {
  const sharedSpaceText = useTranslation('projects.spaces.shared');
  const privateSpaceText = useTranslation('projects.spaces.private');
  const spaces = Object.values(useProjectTemplateSpaces());
  const dispatch = useDispatch();
  const { spaceId } = useParams<{ spaceId: string }>();
  const location = useLocation();
  const parametersArray = location.pathname.split('/');
  const spaceTabId = parametersArray[parametersArray.length - 1];

  const handleAddSpace = (isPrivate) => {
    dispatch(createSpaceInProjectTemplate({ space: { private: isPrivate } }));
  };

  return (
    <>
      <Menu
        mode="inline"
        inlineIndent={16}
        defaultOpenKeys={['private', 'shared']}
        selectedKeys={[spaceId]}
      >
        <MenuGroup
          projectSpaces={spaces.filter((space) => space.private)}
          spaceId={spaceId}
          spaceTabId={spaceTabId}
          title={privateSpaceText}
          onAdd={handleAddSpace}
          isPrivate
        />

        <Menu.Divider />

        <MenuGroup
          projectSpaces={spaces.filter((space) => !space.private)}
          spaceId={spaceId}
          spaceTabId={spaceTabId}
          title={sharedSpaceText}
          onAdd={handleAddSpace}
          isPrivate={false}
        />
      </Menu>
    </>
  );
};
